import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import Select from "react-select";
import {
    GetSheetBulkUploadDataRequest,
    getSmartConnectEmployeeListRequest,
    getSmartConnectHiringListRequest,
} from "../../../Redux/Slice";
import { FaDownload } from "react-icons/fa";
import SmartConnectBulkUploadPopup from "./SmartConnectBulkUploadPopup";
import SmartConnectEditPopup from "./SmartConnectEditPopup";
import { useNavigate } from "react-router-dom";
import yesIcon from "../../../Assets/yes.png";
import errorIcon from "../../../Assets/error.png";
import fileDownloadIcon from "../../../Assets/fileDownload.png";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import swal from "sweetalert2";
import axios from "axios";
import { smartCoonectEmployeePostApi } from "../../../text/apidata";
import { getLoaderAction } from "../../../Redux/Loader";
import { toast } from "react-toastify";

const SmartConnect = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive,
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userSessionData = useSelector((state) => state.users.UserData);

    // Tab State
    const [selectedTab, setSelectedTab] = useState("Employee");

    // Edit Popup State
    const [editPopup, setEditPopup] = useState(false);
    const [selectedEmployeeForEdit, setSelectedEmployeeForEdit] = useState(null);

    // Report Type Filter Options for Employee tab
    const accessOptions = [
        { value: "My Profile", label: "My Profile" },
        { value: "Ticketing", label: "Ticketing" },
        { value: "P2P", label: "Site Request" },

    ]
    const reportTypeFilterOptions = [
        { value: "", label: "All" },
        { value: "0", label: "UDS Billable" },
        { value: "1", label: "UDS Non Billable" },
        { value: "2", label: "Denave Billable" },
        { value: "3", label: "Denave Non Billable" },
        { value: "4", label: "Athena Billable" },
        { value: "5", label: "Athena Non Billable" },
        { value: "6", label: "Avon Billable" },
        { value: "7", label: "Avon Non Billable" },
        { value: "8", label: "Fusion Food Billable" },
        { value: "9", label: "Fusion Food Non Billable" },
        { value: "10", label: "Global Billable" },
        { value: "11", label: "Global Non Billable" },
        { value: "12", label: "Matrix Billable" },
        { value: "13", label: "Matrix Non Billable" },
        { value: "14", label: "WHC Billable" },
        { value: "15", label: "WHC Non Billable" },
    ];

    const [selectedReportType, setSelectedReportType] = useState([
        { value: "", label: "All" },
    ]);

    // Common pagination and search states
    const [sno, setsno] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [search, setsearch] = useState("");
    const [pageSize, setPageSize] = useState(20);
    const [bulkUploadPopup, setBulkUploadPopup] = useState(false);

    // Redux Data
    const { smartConnectEmployeeListData, totalCount: employeeTotalCount } = useSelector(
        (state) => state.smartConnectEmployeeList || {},
    );

    const { sheetBulkUploaddata, totalCount: sheetTotalCount } = useSelector(
        (state) => state.sheetBulkUploadGetData || {},
    );

    const { smartConnectHiringListData, totalCount: hiringTotalCount } = useSelector(
        (state) => state.smartConnectHiringList || {},
    );

    console.log("smartConnectHiringListData", smartConnectHiringListData);


    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };

    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        [],
    );

    const tochange = (e) => {
        setdtPageindex(1);
        debouncedSearch(e);
    };

    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const formatCellValue = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "object") {
            if (Array.isArray(val)) {
                return (
                    val
                        .map((item) =>
                            typeof item === "object" && item !== null
                                ? item?.role || item?.role_name || item?.name || item?.label || item?.department || JSON.stringify(item)
                                : String(item)
                        )
                        .filter(Boolean)
                        .join(", ") || "-"
                );
            }
            return (
                val?.role ||
                val?.role_name ||
                val?.name ||
                val?.label ||
                val?.department ||
                "-"
            );
        }
        return String(val);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage);
    };

    const handlePrevious = (previous) => {
        if (previous !== 0) {
            setdtPageindex(previous);
        }
    };

    const handleDownload = (url) => {
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleTabChange = (tabName) => {
        setSelectedTab(tabName);
        setdtPageindex(1);
        setCurrentPage(1);
        setsno(0);
        setsearch("");
        setSelectedReportType([{ value: "", label: "All" }]);
    };
    console.log(selectedReportType, "ffgfgfgffgg")

    // Fetch Sheet Upload Tab Data
    useEffect(() => {
        if (selectedTab === "Sheet upload") {
            const payload = {
                page_size: 20,
                page: dtpageindex,
                report_type: "4",
            };
            dispatch(GetSheetBulkUploadDataRequest(payload));
        }
    }, [selectedTab, dtpageindex, search, dispatch]);

    // Fetch Hiring Tab Data
    useEffect(() => {
        if (selectedTab === "Hiring") {
            const payload = {
                page_size: 20,
                page: dtpageindex,
                search: search,
            };
            dispatch(getSmartConnectHiringListRequest(payload));
        }
    }, [selectedTab, dtpageindex, search, dispatch]);

    // Polling for Sheet Upload Tab if pending items exist
    useEffect(() => {
        if (selectedTab === "Sheet upload") {
            if (!sheetBulkUploaddata || sheetBulkUploaddata.length === 0) return;

            const hasPending = sheetBulkUploaddata.some((item) => item.status === "0");
            if (!hasPending) return;

            const interval = setInterval(() => {
                dispatch(
                    GetSheetBulkUploadDataRequest({
                        page_size: 20,
                        page: dtpageindex,
                        search: search,
                        report_type: "4",
                    }),
                );
            }, 10000);

            return () => clearInterval(interval);
        }
    }, [selectedTab, sheetBulkUploaddata, dtpageindex, search, dispatch]);

    // Fetch Employee List Helper
    const fetchEmployeeList = () => {
        const payload = {
            page_size: 20,
            page: dtpageindex,
            search: search,
            record_type: selectedReportType?.[0]?.value ?? selectedReportType?.value ?? "",
        };
        dispatch(getSmartConnectEmployeeListRequest(payload));
    };

    // Delete Employee API Handler
    const handleDeleteEmployee = async (id) => {
        try {
            getLoaderAction(true);
            const token = userSessionData?.session?.token;
            const response = await axios({
                method: "delete",
                url: `${smartCoonectEmployeePostApi}${id}/`,
                headers: {
                    Authorization: "Bearer " + token,
                },
            });
            getLoaderAction(false);
            toast.success(
                response?.data?.status?.message || "Employee deleted successfully"
            );
            fetchEmployeeList();
        } catch (error) {
            getLoaderAction(false);
            toast.error(
                error?.response?.data?.status?.message ||
                error?.response?.data?.message ||
                "Failed to delete employee"
            );
        }
    };

    // Delete Confirmation with Swal
    const handleDeleteEmployeeConfirm = (item) => {
        swal.fire({
            title: "Are you sure?",
            text: `Do you want to delete ${item?.employee_name || "this employee"}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ef4d39",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                handleDeleteEmployee(item.id);
            }
        });
    };

    // Fetch Employee Tab Data
    useEffect(() => {
        if (selectedTab === "Employee") {
            fetchEmployeeList();
        }
    }, [selectedTab, dtpageindex, search, selectedReportType, dispatch]);

    // // Polling for Employee Tab
    // useEffect(() => {
    //     if (selectedTab === "Employee") {
    //         const interval = setInterval(() => {
    //             dispatch(
    //                 getSmartConnectEmployeeListRequest({
    //                     page_size: 20,
    //                     page: dtpageindex,
    //                     search: search,
    //                     record_type: selectedReportType?.[0]?.value || "",
    //                 }),
    //             );
    //         }, 15000);
    //         return () => clearInterval(interval);
    //     }
    // }, [selectedTab, dtpageindex, search, selectedReportType, dispatch]);

    // Employee Table Columns
    const employeeColumns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },
            {
                Header: "Employee Name",
                accessor: "employee_name",
                Cell: (row) => {
                    return (
                        <span className="wrap-cell" style={{ minWidth: "150px", maxWidth: "200px" }}>
                            {formatCellValue(row.row.original?.employee_name)}
                        </span>
                    );
                },
            },
            {
                Header: "Employee Code",
                accessor: "employee_code",
                Cell: (row) => {
                    return <span>{formatCellValue(row.row.original?.employee_code)}</span>;
                },
            },
            {
                Header: "Phone Number",
                accessor: "phone_number",
                Cell: (row) => {
                    return <span>{formatCellValue(row.row.original?.phone_number)}</span>;
                },
            },
            {
                Header: "Email",
                accessor: "email",
                Cell: (row) => {
                    return <span>{formatCellValue(row.row.original?.email)}</span>;
                },
            },
            {
                Header: "Role",
                accessor: "role",
                Cell: (row) => {
                    return (
                        <span className="wrap-cell" style={{ minWidth: "120px", maxWidth: "180px" }}>
                            {formatCellValue(row.row.original?.role)}
                        </span>
                    );
                },
            },
            {
                Header: "Type",
                accessor: "record_type",
                Cell: (row) => {
                    let dep = row.row.original?.record_type !== undefined && row.row.original?.record_type !== null
                        ? row.row.original?.record_type
                        : row.row.original?.department;
                    if (typeof dep === "object" && dep !== null) {
                        dep = dep.record_type ?? dep.department ?? dep.name ?? dep.id;
                    }
                    if (dep === '0' || dep === 0) {
                        return <span>UDS Billable</span>;
                    } else if (dep === '1' || dep === 1) {
                        return <span>UDS Non Billable</span>;
                    } else if (dep === '2' || dep === 2) {
                        return <span>Denave Billable</span>;
                    }
                    else if (dep === '3' || dep === 3) {
                        return <span>Denave Non Billable</span>;
                    } else if (dep === '4' || dep === 4) {
                        return <span>Athena Billable</span>;
                    }
                    else if (dep === '5' || dep === 5) {
                        return <span>Athena Non Billable</span>;
                    }
                    else if (dep === '6' || dep === 6) {
                        return <span>Avon Billable</span>;
                    }
                    else if (dep === '7' || dep === 7) {
                        return <span>Avon Non Billable</span>;
                    }
                    else if (dep === '8' || dep === 8) {
                        return <span>Fusion Food Billable</span>;
                    }
                    else if (dep === '9' || dep === 9) {
                        return <span>Fusion Food Non Billable</span>;
                    }
                    else if (dep === '10' || dep === 10) {
                        return <span>Global Billable</span>;
                    }
                    else if (dep === '11' || dep === 11) {
                        return <span>Global Non Billable</span>;
                    }
                    else if (dep === '12' || dep === 12) {
                        return <span>Matrix Billable</span>;
                    }
                    else if (dep === '13' || dep === 13) {
                        return <span>Matrix Non Billable</span>;
                    }
                    else if (dep === '14' || dep === 14) {
                        return <span>WHC Billable</span>;
                    }
                    else if (dep === '15' || dep === 15) {
                        return <span>WHC Non Billable</span>;
                    }
                    else {
                        return <span>{formatCellValue(dep)}</span>;
                    }
                },
            },
            {
                Header: "Department",
                accessor: "department",
                Cell: (row) => {
                    return <span>{formatCellValue(row.row.original?.department)}</span>;
                },
            },
            {
                Header: "Access",
                accessor: "access",
                Cell: (row) => {
                    return (
                        <span className="wrap-cell" style={{ minWidth: "160px", maxWidth: "240px" }}>
                            {formatCellValue(Array.isArray(row.row.original?.access) ? row.row.original.access.map((a) => (a === "P2P" ? "Site Request" : a === "C2C" ? "Business Development" : a)) : row.row.original?.access)}
                        </span>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "is_active",
                Cell: (row) => {
                    const isActive = row.row.original?.is_active;
                    if (isActive === true || isActive === "true" || isActive === "1" || isActive === 1) {
                        return <span>Active</span>;
                    }
                    if (isActive === false || isActive === "false" || isActive === "0" || isActive === 0) {
                        return <span>Inactive</span>;
                    }
                    return <span>{formatCellValue(isActive)}</span>;
                },
            },
            {
                Header: "Created Date",
                accessor: "created_at",
                Cell: (row) => {
                    const dateString = row.row.original?.created_at;
                    if (!dateString) return "-";
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {`${dateString.slice(0, 10)}  ${formattedTime}`}
                        </span>
                    );
                },
            },
            {
                Header: "Actions",
                accessor: "",
                Cell: (row) => {
                    const item = row.row.original;
                    return (
                        <div
                            className="actions"
                            style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                gap: "5px",
                            }}
                        >
                            <button
                                type="button"
                                className="btn Status"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedEmployeeForEdit(item);
                                    setEditPopup(true);
                                }}
                            >
                                <span className="OuterActionSpan">
                                    <span className="EditImages">
                                        <img src={EditImages} alt="edit" />
                                    </span>
                                    <span className="ActionsList"> Edit </span>
                                </span>
                            </button>

                            <button
                                type="button"
                                className="btn Status"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteEmployeeConfirm(item);
                                }}
                            >
                                <span className="OuterActionSpan">
                                    <span className="EditImages">
                                        <img src={DeleteImages} alt="delete" />
                                    </span>
                                    <span className="ActionsList"> Delete </span>
                                </span>
                            </button>
                        </div>
                    );
                },
            },
        ],
        [smartConnectEmployeeListData, sno],
    );

    // Sheet Upload Table Columns
    const sheetUploadColumns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },
            {
                Header: "Created Date",
                accessor: "created_at",
                Cell: (row) => {
                    const dateString = row.row.original?.created_at;
                    if (!dateString) return "-";
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <span>
                            {`${dateString.slice(0, 10)}  ${formattedTime}`}
                        </span>
                    );
                },
            },
            {
                Header: "File Name",
                accessor: "file_name",
                Cell: (row) => {
                    const fileName = row.row.original?.file_name;
                    return (
                        <span
                            style={{
                                width: "160px",
                                display: "inline-block",
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                textWrap: "wrap",
                            }}
                        >
                            {fileName || "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Report Type",
                accessor: "report_type",
                Cell: (row) => {
                    const reportType = row.row.original?.report_type;
                    const recordType = row.row.original?.record_type;
                    const type = recordType !== undefined && recordType !== null ? recordType : reportType;
                    return (
                        <span>
                            {type === "0" || type === 0
                                ? "UDS Billable"
                                : type === "1" || type === 1
                                    ? "UDS Non Billable"
                                    : type === "2" || type === 2
                                        ? "Denave Billable"
                                        : type === "3" || type === 3
                                            ? "Denave Non Billable"
                                            : type === "4" || type === 4
                                                ? "Smart Connect"
                                                : type || "-"}
                        </span>
                    );
                },
            },
            {
                Header: "Total Count",
                accessor: "total_count",
                Cell: (row) => {
                    return <span>{row.row.original?.total_count ?? 0}</span>;
                },
            },
            {
                Header: "Sucess Count",
                accessor: "valid_count",
                Cell: (row) => {
                    return <span>{row.row.original?.valid_count ?? 0}</span>;
                },
            },
            {
                Header: "Defect Count",
                accessor: "defect_count",
                Cell: (row) => {
                    return <span>{row.row.original?.defect_count ?? 0}</span>;
                },
            },
            {
                Header: "Uploaded Sheet",
                accessor: "uploaded_sheet",
                Cell: (row) => {
                    const url = row.row.original?.uploaded_sheet;
                    return url ? (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDownload(url)}
                            title="Download Uploaded Sheet"
                        >
                            <FaDownload size={18} />
                        </span>
                    ) : (
                        "-"
                    );
                },
            },
            {
                Header: "Defect Sheet",
                accessor: "defect_sheet",
                Cell: (row) => {
                    const url = row.row.original?.defect_sheet;
                    return url ? (
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDownload(url)}
                            title="Download Defect Sheet"
                        >
                            <FaDownload size={18} />
                        </span>
                    ) : (
                        "-"
                    );
                },
            },
            {
                Header: "Process",
                accessor: "upload_status",
                Cell: (row) => {
                    return (
                        <span>
                            {Math.round(Number(row.row.original?.upload_status || 0))}%
                        </span>
                    );
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: (row) => {
                    const status = row.row.original?.status;
                    return (
                        <span>
                            {status === "0" || status === 0
                                ? "Pending"
                                : status === "1" || status === 1
                                    ? "Completed"
                                    : status === "2" || status === 2
                                        ? "Failed"
                                        : status || "-"}
                        </span>
                    );
                },
            },
        ],
        [sheetBulkUploaddata, sno],
    );

    // Hiring Table Columns
    const hiringColumns = useMemo(
        () => [
            {
                Header: "S.NO",
                accessor: "",
                Cell: (row) => {
                    return <p>{Number(sno + row.row.index + 1)}</p>;
                },
            },
            {
                Header: "Employee Name",
                accessor: "first_name",
                Cell: (row) => {
                    const orig = row.row.original;
                    const fullName = [orig?.first_name, orig?.last_name].filter(Boolean).join(" ");
                    const name = fullName || orig?.employee_name || "-";
                    return (
                        <span
                            style={{
                                width: "160px",
                                display: "inline-block",
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                textWrap: "wrap",
                            }}
                        >
                            {name}
                        </span>
                    );
                },
            },
            {
                Header: "Reference No",
                accessor: "reference_no",
                Cell: (row) => {
                    const orig = row.row.original;
                    return <span>{orig?.reference_no || orig?.employee_code || "-"}</span>;
                },
            },
            {
                Header: "Phone Number",
                accessor: "phone_number",
                Cell: (row) => {
                    return <span>{row.row.original?.phone_number || "-"}</span>;
                },
            },

            {
                Header: "Shift",
                accessor: "shift",
                Cell: (row) => {
                    const orig = row.row.original;
                    return <span>{orig?.shift || "-"}</span>;
                },
            },
            {
                Header: "Experience",
                accessor: "is_fresher",
                Cell: (row) => {
                    const orig = row.row.original;
                    return <span>{orig?.is_fresher ? "Fresher" : "Experience" || "-"}</span>;
                },
            },
            {
                Header: "Role",
                accessor: "role",
                Cell: (row) => {
                    const roleVal = row.row.original?.role;
                    return (
                        <span>
                            {typeof roleVal === "object" && roleVal !== null
                                ? roleVal?.role || roleVal?.name || "-"
                                : formatCellValue(roleVal)}
                        </span>
                    );
                },
            },
            {
                Header: "Employment Type",
                accessor: "employment_type",
                Cell: (row) => {
                    const orig = row.row.original;
                    if (orig?.employment_type) {
                        return <span>{orig.employment_type}</span>;
                    }
                    const dep = orig?.record_type !== undefined && orig?.record_type !== null
                        ? orig?.record_type
                        : orig?.department;
                    if (typeof dep === "object" && dep !== null) {
                        return <span>{dep.record_type ?? dep.department ?? dep.name ?? dep.id ?? "-"}</span>;
                    }
                    if (dep === '0' || dep === 0) return <span>UDS Billable</span>;
                    if (dep === '1' || dep === 1) return <span>UDS Non Billable</span>;
                    if (dep === '2' || dep === 2) return <span>Denave Billable</span>;
                    if (dep === '3' || dep === 3) return <span>Denave Non Billable</span>;
                    return <span>{formatCellValue(dep)}</span>;
                },
            },
            {
                Header: "Hiring Manager Email",
                accessor: "hiring_manager_email",
                Cell: (row) => {
                    const orig = row.row.original;
                    return <span>{orig?.hiring_manager_email || "-"}</span>;
                },
            },
            {
                Header: "Hiring Manager",
                accessor: "hiring_manager_name",
                Cell: (row) => {
                    const orig = row.row.original;
                    return <span>{orig?.hiring_manager_name || formatCellValue(orig?.department)}</span>;
                },
            },
            {
                Header: "Target Joining Date",
                accessor: "target_joining_date",
                Cell: (row) => {
                    const orig = row.row.original;
                    return <span>{orig?.target_joining_date || "-"}</span>;
                },
            },
            {
                Header: "Created Date",
                accessor: "created_at",
                Cell: (row) => {
                    const dateString = row.row.original?.created_at;
                    if (!dateString) return "-";
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
                    return (
                        <span style={{ textWrap: "nowrap" }}>
                            {`${dateString.slice(0, 10)}  ${formattedTime}`}
                        </span>
                    );
                },
            },
        ],
        [smartConnectHiringListData, sno],
    );
    const currentData =
        selectedTab === "Employee"
            ? (Array.isArray(smartConnectEmployeeListData)
                ? smartConnectEmployeeListData
                : smartConnectEmployeeListData?.results || [])
            : selectedTab === "Hiring"
                ? (Array.isArray(smartConnectHiringListData)
                    ? smartConnectHiringListData
                    : smartConnectHiringListData?.results || [])
                : (Array.isArray(sheetBulkUploaddata)
                    ? sheetBulkUploaddata
                    : sheetBulkUploaddata?.results || []);

    const currentTotalCount =
        selectedTab === "Employee"
            ? employeeTotalCount || 0
            : selectedTab === "Hiring"
                ? hiringTotalCount || 0
                : sheetTotalCount || 0;

    return (
        <div className={stateDisplay ? "outterContent" : "inner-Content"}>
            {/* Header Bar */}
            <div
                className="Header-Details ClientBranch"
                style={{
                    padding: "14px 28px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px !important",
                }}
            >
                <div
                    className="col-sm-7 auto"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            gap: "25px",
                            borderBottom: "1px solid #dee2e6",
                            width: "100%",
                        }}
                    >
                        <span
                            className="user-name mb-0"
                            style={{
                                cursor: "pointer",
                                fontSize: "18px",
                                fontWeight: selectedTab === "Employee" ? "600" : "400",
                                color: selectedTab === "Employee" ? "#f26639" : "#6b7280",
                                borderBottom:
                                    selectedTab === "Employee"
                                        ? "3px solid #f26639"
                                        : "3px solid transparent",
                                paddingBottom: "8px",
                                transition: "all 0.3s ease",
                            }}
                            onClick={() => handleTabChange("Employee")}
                        >
                            Employee
                        </span>

                        <span
                            className="user-name mb-0"
                            style={{
                                cursor: "pointer",
                                fontSize: "18px",
                                fontWeight: selectedTab === "Sheet upload" ? "600" : "400",
                                color: selectedTab === "Sheet upload" ? "#f26639" : "#6b7280",
                                borderBottom:
                                    selectedTab === "Sheet upload"
                                        ? "3px solid #f26639"
                                        : "3px solid transparent",
                                paddingBottom: "8px",
                                transition: "all 0.3s ease",
                            }}
                            onClick={() => handleTabChange("Sheet upload")}
                        >
                            Sheet upload
                        </span>

                        <span
                            className="user-name mb-0"
                            style={{
                                cursor: "pointer",
                                fontSize: "18px",
                                fontWeight: selectedTab === "Hiring" ? "600" : "400",
                                color: selectedTab === "Hiring" ? "#f26639" : "#6b7280",
                                borderBottom:
                                    selectedTab === "Hiring"
                                        ? "3px solid #f26639"
                                        : "3px solid transparent",
                                paddingBottom: "8px",
                                transition: "all 0.3s ease",
                            }}
                            onClick={() => handleTabChange("Hiring")}
                        >
                            Hiring
                        </span>
                    </div>
                </div>

                <div
                    className="Add-User col-sm-5"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        justifyContent: "flex-end",
                    }}
                >
                    {selectedTab === "Sheet upload" && (
                        <button
                            onClick={() => setBulkUploadPopup(true)}
                            className="ButtonCSS"
                            style={{ marginBottom: "10px" }}
                        >
                            Bulk Upload
                        </button>
                    )}
                </div>
            </div>

            {/* Table Section */}
            <div
                className={selectedTab === "Employee" ? "smartconnect-employee-table" : undefined}
                style={{
                    padding: "0px 40px",
                    marginTop: "-13px",
                    marginBottom: "20px",
                }}
            >
                {/* Employee tab only: keep cells on one line and scroll horizontally (table-responsive wrapper) */}
                <style>{`
                    .smartconnect-employee-table .table-responsive { overflow-x: auto; container-type: inline-size; }
                    .smartconnect-employee-table .INNERTABLE { width: max-content; min-width: 100%; }
                    .smartconnect-employee-table .Dusbinbacktabls { position: sticky; left: 0; width: 100cqw; }
                    .smartconnect-employee-table .table-responsive > .row { position: sticky; left: 0; width: 100cqw !important; }
                    .smartconnect-employee-table .TableDesgin { min-width: 1500px; }
                    .smartconnect-employee-table .TableDesgin th {
                        width: auto !important;
                        white-space: nowrap;
                        vertical-align: middle;
                        padding: 12px 14px !important;
                    }
                    .smartconnect-employee-table .TableDesgin td {
                        white-space: nowrap;
                        vertical-align: middle;
                        padding: 12px 14px !important;
                    }
                    .smartconnect-employee-table .TableDesgin td p { margin: 0; }
                    .smartconnect-employee-table .wrap-cell {
                        display: inline-block;
                        white-space: normal;
                        word-break: break-word;
                    }
                `}</style>
                <ReactTable
                    data={currentData}
                    columns={selectedTab === "Employee" ? employeeColumns : selectedTab === "Hiring" ? hiringColumns : sheetUploadColumns}
                    currentPage={currentPage}
                    onChange={tochange}
                    setCurrentPage={setCurrentPage}
                    pagesize={pagesize}
                    dtpagesize={pageSize}
                    dtpageindex={dtpageindex}
                    pageindex={pageindex}
                    totalItems={currentTotalCount}
                    datacount={currentTotalCount}
                    MakeCreate={false}
                    onPrevious={handlePrevious}
                    onNextpage={handleNext}
                    GotoEnteredPage={GotoEnteredPage}
                    placeHold={"All"}
                    setsno={setsno}
                    sno={sno}
                    id={"spe"}
                    filterLabel={"Type"}
                    options={reportTypeFilterOptions}
                    values={selectedReportType}
                    count={(cnt, label, val, selectedObj) => {
                        setSelectedReportType(selectedObj ? [selectedObj] : [{ value: "", label: "All" }]);
                        setdtPageindex(1);
                        setCurrentPage(1);
                        setsno(0);
                    }}
                    ClearState={() => {
                        setSelectedReportType([{ value: "", label: "All" }]);
                        setdtPageindex(1);
                        setCurrentPage(1);
                        setsno(0);
                    }}
                    ApproveRequestFilter={selectedTab === "Employee"}
                    Filter={selectedTab === "Employee" || selectedTab === "Hiring"}
                    NoFilter={selectedTab === "Hiring"}
                    search_key={selectedTab === "Employee" || selectedTab === "Hiring"}
                    searchVal={search}
                    nostatusFilter={selectedTab === "Hiring"}
                />
            </div>

            {/* Bulk Upload Modal */}
            {bulkUploadPopup && (
                <SmartConnectBulkUploadPopup setPopup={setBulkUploadPopup} />
            )}

            {/* Edit Employee Modal */}
            {editPopup && selectedEmployeeForEdit && (
                <SmartConnectEditPopup
                    employeeData={selectedEmployeeForEdit}
                    setEditPopup={setEditPopup}
                    refreshList={fetchEmployeeList}
                />
            )}
        </div>
    );
};

export default SmartConnect;